import { Component } from '@angular/core';

@Component({
  selector: 'loading-event-card',
  templateUrl: './loading-event-card.component.html',
  styleUrls: ['./loading-event-card.component.scss']
})
export class LoadingEventCardComponent {}
